import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Cómo recibo el Profe de Natación Resuelto después de comprar?',
  a: 'Inmediatamente después de confirmar el pago recibís un email con el link de descarga de todos los PDFs. Acceso en menos de 5 minutos desde cualquier dispositivo: celular, tablet o computadora.'
}, {
  q: '¿Sirve para profes con poca experiencia o solo para los avanzados?',
  a: 'Sirve para todos los niveles. El sistema está diseñado desde los fundamentos hasta los conceptos más avanzados. Tanto si estás empezando como si llevás años en la pileta, vas a encontrar contenido que podés aplicar desde el primer día.'
}, {
  q: '¿Es editable? ¿Puedo modificarlo?',
  a: 'Los PDFs están protegidos con derechos de autor. Podés usarlos para preparar tus clases, imprimirlos para tu uso personal y consultarlos cuando quieras. No están habilitados para edición ni distribución a terceros.'
}, {
  q: '¿Los 6 bonos están en las dos ofertas?',
  a: 'Sí. Los 6 bonos estratégicos están incluidos en las dos opciones sin costo adicional. La diferencia entre las ofertas son los 2 módulos exclusivos del Pack Élite™.'
}, {
  q: '¿Sirve si doy clases individuales o solo para grupos?',
  a: 'Sirve para las dos modalidades. El sistema incluye clases y fichas adaptadas tanto para el trabajo individual como grupal, con variantes para cada contexto.'
}, {
  q: '¿Sirve si tengo alumnos de distintos niveles al mismo tiempo?',
  a: 'Sí, específicamente. Uno de los problemas que resuelve el sistema es exactamente ese: cómo manejar grupos heterogéneos con variaciones por nivel para que todos progresen dentro de la misma clase.'
}, {
  q: '¿Qué diferencia tiene con otros materiales de natación del mercado?',
  a: 'Es el único sistema integral en Argentina diseñado específicamente para profes de natación que cubre técnica, planificación, grupos especiales, preparación física y gestión profesional en un solo producto. No es un libro teórico — es un sistema listo para aplicar desde el primer día.'
}, {
  q: '¿Por qué elegir el Pack Élite y no el estándar?',
  a: 'Si además de dar buenas clases querés preparar nadadores para competencia y construir tu propia escuela de natación rentable, el Pack Élite es tu opción. Tiene todo el sistema base más los dos módulos que te llevan al siguiente nivel profesional.'
}, {
  q: '¿Tiene garantía real?',
  a: 'Sí. 7 días de garantía total. Si por cualquier motivo no es lo que esperabas, te devolvemos el 100% del dinero sin preguntas ni formularios. Podés contactarnos por Instagram o email y listo.'
}];
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-white py-8 sm:py-16 px-4 sm:px-6 lg:px-8" data-id="element-91">
      <div className="max-w-3xl mx-auto" data-id="element-92">
        <h2 className="text-3xl sm:text-4xl font-black text-deep mb-6 sm:mb-10 text-center" data-id="element-93">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-0 border-t border-gray-200" data-id="element-94">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={index} className="border-b border-gray-200" data-id="element-95">
                <button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full text-left py-3 sm:py-5 flex items-center justify-between focus:outline-none group" data-id="element-96">
                  <span className={`font-bold pr-6 transition-colors ${isOpen ? 'text-agua' : 'text-deep group-hover:text-agua'}`} data-id="element-97">
                    {faq.q}
                  </span>
                  <ChevronDown className={`w-5 h-5 shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180 text-agua' : 'text-gray-400 group-hover:text-agua'}`} data-id="element-98" />
                </button>

                <AnimatePresence data-id="element-99">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} className="overflow-hidden" data-id="element-100">
                      <div className="pb-5 text-gray-600 leading-relaxed bg-light/50 p-4 rounded-lg mb-4" data-id="element-101">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}